import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class ExportacaoLeadService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'exportacao-lead';
    this.token = new Login();
  }

  all(page = 1, buscar = '', paginate = 10, dataInicial: any = '', dataFinal: any = ''){
    return this.http.get<Object[]>(this.url + '?page=' + page + '&q=' + buscar + '&paginate=' + paginate + '&data_inicial=' + dataInicial + '&data_final=' + dataFinal, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  download(id: any){
    return this.http.post<Object[]>(this.url + '/' + id, {}, {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  solicitar(form: any){
    return this.http.post<Object[]>(this.url, form, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
